import GroupIcon from "@mui/icons-material/Group";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BULK_TYPE } from "../../../../helpers/constants";
import { commonSiteCoreKeys } from "../../../../helpers/constants/siteCoreKeys";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { siteCoreContentLoadingSelector } from "../../../../redux/slices/appState/appStateSelector";
import { bulkCreateProgramSiteCoreKeys } from "../../../bulkCreateProgram/siteCore/siteCoreKeys";
import { bulkTransferSiteCoreKeys } from "../../../createBulkTransfer/siteCore/SiteCoreKeys";
import { bulkActivitySiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import {
  CountText,
  IconBox,
  IconCircle,
  LabelText,
  SummaryCardWrapper,
} from "./SummaryCard.style";

export const SUMMARY_CARD_TYPE = {
  total: "total",
  processed: "processed",
  unprocessed: "unprocessed",
  activities: "activities",
  totalNumberOfPrograms: "totalNumberOfPrograms",
} as const;

type SummaryCardType = keyof typeof SUMMARY_CARD_TYPE;

interface Props {
  type: SummaryCardType;
  count: number;
  label: string;
  bulkType?: string;
}

export const SummaryCard = ({ type, count, label, bulkType }: Props) => {
  const { fetchMediaListImage } = useSiteCore();
  const siteCoreLoading = useSelector(siteCoreContentLoadingSelector);
  const [totalNumberOfRecords, setTotalNumberOfRecords] = useState<any>();

  useEffect(() => {
    if (siteCoreLoading) return;
    if (bulkType === BULK_TYPE.PROGRAM) {
      setTotalNumberOfRecords(
        fetchMediaListImage(
          bulkCreateProgramSiteCoreKeys.summaryComponent,
          bulkCreateProgramSiteCoreKeys.totalNumberOfProgramsIcon,
          commonSiteCoreKeys.smallImage,
        ),
      );
    } else if (bulkType === BULK_TYPE.TRANSFER) {
      setTotalNumberOfRecords(
        fetchMediaListImage(
          bulkTransferSiteCoreKeys.bulkParticipantSummary,
          bulkTransferSiteCoreKeys.totalNumberOfProgramsIcon,
          commonSiteCoreKeys.smallImage,
        ),
      );
    } else if (bulkType === BULK_TYPE.ACTIVITY) {
      setTotalNumberOfRecords(
        fetchMediaListImage(
          bulkActivitySiteCoreKeys.addBulkActivitySummary,
          bulkActivitySiteCoreKeys.totalNumberOfProgramsIcon,
          commonSiteCoreKeys.smallImage,
        ),
      );
    }
  }, [bulkType, siteCoreLoading]);

  const iconMap: Record<SummaryCardType, JSX.Element> = {
    total: <GroupIcon />,
    processed: <TaskAltIcon />,
    unprocessed: <HighlightOffIcon />,
    activities: <ListOutlinedIcon />,
    totalNumberOfPrograms: (
      <img
        src={totalNumberOfRecords?.ImageUrl}
        alt={totalNumberOfRecords?.AltText}
      />
    ),
  };
  const icon = iconMap[type];
  return (
    <SummaryCardWrapper>
      <IconBox type={type}>
        <IconCircle type={type}>{icon}</IconCircle>
        <CountText type={type}>{count?.toString().padStart(2, "0")}</CountText>
      </IconBox>
      <LabelText>{label}</LabelText>
    </SummaryCardWrapper>
  );
};
